/* Code for Slick Slider - Multi Column - Redefine*/
$(document).ready(function () {
  $(".rd-category-slider").slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    speed: 300,
    dots: true,
    variableWidth: true,
    prevArrow:
      '<div class="slick-prev"><svg class="icon icon-arrow-left" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6896.811,15689.089,6889,15696.9l7.811,7.812" transform="translate(-6886.879 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    nextArrow:
      '<div class="slick-next"><svg class="icon icon-arrow-right" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6889,15689.089l7.811,7.811-7.811,7.812" transform="translate(-6887.939 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          variableWidth: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".rd-aboutblock-slider").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 300,
    dots: true,
    variableWidth: true,
    prevArrow:
      '<div class="slick-prev"><svg class="icon icon-arrow-left" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6896.811,15689.089,6889,15696.9l7.811,7.812" transform="translate(-6886.879 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    nextArrow:
      '<div class="slick-next"><svg class="icon icon-arrow-right" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6889,15689.089l7.811,7.811-7.811,7.812" transform="translate(-6887.939 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".rd-customer-review").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 300,
    prevArrow:
      '<div class="slick-prev"><svg class="icon icon-arrow-left" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6896.811,15689.089,6889,15696.9l7.811,7.812" transform="translate(-6886.879 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    nextArrow:
      '<div class="slick-next"><svg class="icon icon-arrow-right" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6889,15689.089l7.811,7.811-7.811,7.812" transform="translate(-6887.939 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    dots: false,
    arrows: true,
  });
  $(".rd-slickslider-italy").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 300,
    prevArrow:
      '<div class="slick-prev"><svg class="icon icon-arrow-left" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6896.811,15689.089,6889,15696.9l7.811,7.812" transform="translate(-6886.879 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    nextArrow:
      '<div class="slick-next"><svg class="icon icon-arrow-right" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6889,15689.089l7.811,7.811-7.811,7.812" transform="translate(-6887.939 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    dots: true,
    centerMode: true,
    variableWidth: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".rd-slickslider-1").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 300,
    prevArrow:
      '<div class="slick-prev"><svg class="icon icon-arrow-left" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6896.811,15689.089,6889,15696.9l7.811,7.812" transform="translate(-6886.879 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    nextArrow:
      '<div class="slick-next"><svg class="icon icon-arrow-right" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6889,15689.089l7.811,7.811-7.811,7.812" transform="translate(-6887.939 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".rd-slickslider-2").slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    speed: 300,
    prevArrow:
      '<div class="slick-prev"><svg class="icon icon-arrow-left" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6896.811,15689.089,6889,15696.9l7.811,7.812" transform="translate(-6886.879 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    nextArrow:
      '<div class="slick-next"><svg class="icon icon-arrow-right" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6889,15689.089l7.811,7.811-7.811,7.812" transform="translate(-6887.939 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    dots: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".rd-slickslider-3").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 300,
    dots: true,
    variableWidth: true,
    prevArrow:
      '<div class="slick-prev"><svg class="icon icon-arrow-left" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6896.811,15689.089,6889,15696.9l7.811,7.812" transform="translate(-6886.879 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    nextArrow:
      '<div class="slick-next"><svg class="icon icon-arrow-right" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6889,15689.089l7.811,7.811-7.811,7.812" transform="translate(-6887.939 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".rd-slickslider-4").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 300,
    dots: false,
    prevArrow:
      '<div class="slick-prev"><svg class="icon icon-arrow-left" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6896.811,15689.089,6889,15696.9l7.811,7.812" transform="translate(-6886.879 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    nextArrow:
      '<div class="slick-next"><svg class="icon icon-arrow-right" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6889,15689.089l7.811,7.811-7.811,7.812" transform="translate(-6887.939 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(window).on("load resize", function () {
    // $(window).width() > 1299 && $('.rd-featureproduct-slider').slick({
    //     infinite: true,
    //     speed: 300,
    //     dots: false,
    //     arrow: false,
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     prevArrow: '<div class="slick-prev"><svg class="icon icon-arrow-left" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6896.811,15689.089,6889,15696.9l7.811,7.812" transform="translate(-6886.879 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    //     nextArrow: '<div class="slick-next"><svg class="icon icon-arrow-right" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6889,15689.089l7.811,7.811-7.811,7.812" transform="translate(-6887.939 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
    //     responsive: [{
    //         breakpoint: 1024,
    //         settings: {
    //           slidesToShow: 2,
    //           slidesToScroll: 1
    //         }
    //       },
    //       {
    //         breakpoint: 767,
    //         settings: {
    //           slidesToShow: 1,
    //           slidesToScroll: 1
    //         }
    //       }
    //     ]
    // });

    $(window).width() < 1024 &&
      $(".related-products-slick").slick({
        infinite: true,
        speed: 300,
        dots: false,
        arrow: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        prevArrow:
          '<div class="slick-prev"><svg class="icon icon-arrow-left" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6896.811,15689.089,6889,15696.9l7.811,7.812" transform="translate(-6886.879 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
        nextArrow:
          '<div class="slick-next"><svg class="icon icon-arrow-right" width="10.992" height="17.743" viewBox="0 0 10.992 17.743"><path d="M6889,15689.089l7.811,7.811-7.811,7.812" transform="translate(-6887.939 -15688.028)" fill="none" stroke="currentColor" stroke-width="3"/></svg></div>',
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
  });
});
